__turbopack_context__.v({
  "root": "Meter-module__pKiNka__root",
});
